import useFeaturePermissions from './useFeaturePermissions';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity custom fields
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useCustomFieldsPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(organizationId, Permissions.CustomFieldsChange, Permissions.CustomFieldsRead);
  return { writePermission, readPermission };
};
